import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { sortColumnsSchema } from '../sortColumnsSchema';

export const equipmentHistoryPaths = {
    '/api/equipment/{equipmentId}/equipmentHistory/': {
        parameters: [createPathGuidParameter('equipmentId')],
        post: {
            operationId: 'equipmentHistoryControllers.create',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.Optional(Type.String()),
                                equipmentId: Type.Optional(Type.String()),
                                description: Type.Optional(Type.String()),
                                date: Type.Optional(Type.String()),
                                type: Type.String(),
                                userId: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            id: Type.Optional(Type.String()),
                            equipmentId: Type.Optional(Type.String()),
                            description: Type.Optional(Type.String()),
                            date: Type.Optional(Type.String()),
                            type: Type.String(),
                            userId: Type.Optional(Type.String()),
                        }),
                    },
                },
            },
        },
        get: {
            operationId: 'equipmentHistoryControllers.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                total: Type.Number(),
                                items: Type.Array(
                                    Type.Object({
                                        description: Type.String(),
                                        id: Type.String(),
                                        type: Type.String(),
                                        date: Type.String(),
                                        created_at: Type.String(),
                                        user: Type.Object({
                                            firstName: Type.String(),
                                            lastName: Type.String(),
                                        }),
                                    }),
                                ),
                            }),
                        },
                    },
                },
            },
            parameters: [
                { name: 'limit', in: 'query', schema: Type.String(), required: true },
                { name: 'offset', in: 'query', schema: Type.String(), required: true },
                { name: 'sortColumns', in: 'query', schema: sortColumnsSchema, required: true },
            ],
        },
    },
    '/api/equipmentHistory/{equipmentHistoryId}': {
        parameters: [createPathGuidParameter('equipmentHistoryId')],
        delete: {
            operationId: 'equipmentHistoryControllers.remove',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
